@if (strategy(); as strategy) {
  <div *transloco="let t">
    <div class="mx-8 mb-4">
      <app-low-inventory-warning
        [accountId]="strategy.accountId"
        [marketplace]="strategy.marketplace"
        [asins]="strategy.asins | map: getAsins"
      ></app-low-inventory-warning>
    </div>
    @if (strategy.campaignType !== CampaignType.DSP && ineligibleAsins().length > 0) {
      <div class="mx-8 mb-4">
        <IAlert
          type="warning"
          [collapsable]="true"
          [title]="t('sd-page.ineligible_asins', { count: ineligibleAsins().length })"
        >
          {{ ineligibleAsins().length > 1 ? t("common.asins") : t("common.asin") }}:
          {{ ineligibleAsins().slice(0, 20).join(", ") }}{{ ineligibleAsins().length > 20 ? ", …" : "" }}
        </IAlert>
      </div>
    }
    <div>
      <div class="flex h-[35rem] px-8">
        <app-asin-selection-wrapper
          class="w-full"
          [withDelete]="selectedAsins().length > 0 && !isReadOnly() && !strategy.defaultStrategy"
          [withEdit]="!isReadOnly() && !strategy.defaultStrategy"
          [withMove]="selectedAsins().length > 0 && !isReadOnly()"
          (deleteClicked)="deleteAsinsFromStrategy(selectedAsins())"
          (editClicked)="toggleProductAdd()"
          (moveClicked)="moveStrategyAsins()"
        >
          <div class="flex items-center pb-2 font-medium text-gray-800">
            <span>{{ t("common.asins_count", { count: asinsList().length }) }}</span>
            @if (brands().size > 0) {
              <span [iTooltip]="getBrands()">&nbsp;- {{ t("sd-page.num_brand", { count: brands().size }) }}</span>
            }
            <app-limit-warning
              [current]="asinsList() ? asinsList().length : 0"
              [limit]="ASINS_LIMIT"
              [message]="t('sd-page.too_many_asins', [ASINS_LIMIT])"
              class="ml-1"
            >
            </app-limit-warning>
          </div>
          <app-asin-selection
            ineligibilityTag="SP"
            [customList]="asinsList()"
            [readonly]="isReadOnly() || strategy.defaultStrategy"
            [csvExport]="true"
            [selectedAsins]="selectedAsins()"
            [asinsLimit]="ASINS_LIMIT"
            (selectedAsinsChange)="selectedAsins.set($event)"
          />
        </app-asin-selection-wrapper>
      </div>
    </div>

    <ng-template #productAdd>
      <div class="flex h-full flex-col">
        <div class="min-h-0 flex-1">
          <app-asin-selection
            ineligibilityTag="SP"
            [selectedAsins]="asinsList()"
            [disabledAsins]="disabledAsinsToAdd()"
            [asinsLimit]="ASINS_LIMIT"
            (selectedAsinsChange)="newEditList.set($event)"
          />
        </div>
        <div class="flex shrink-0 justify-end gap-2 p-2">
          <button iButton variant="secondary" size="md" (click)="productModalRef?.close()">
            {{ t("common.cancel") }}
          </button>
          <button
            iButton
            size="md"
            testId="btn-save"
            [loading]="isUpdatingAsins()"
            (click)="updateStrategyAsinsFromModal()"
          >
            {{ t("common.update") }}
          </button>
        </div>
      </div>
    </ng-template>
  </div>
}
